export default __webpack_public_path__ + "static/media/instagram.529f7d48.svg";